var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-sm"},[(_vm.userid!='0')?_c('WorkOnDocument',{key:_vm.vueKeyToForceRefresh,attrs:{"appid":_vm.appid,"withFinalizeButton":"no"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }